module.exports = __webpack_public_path__ + "img/gb9113_13_b.prt.e0d88dba.jpg";